import { whenDomReady } from "@allwyn/utils/document-ready";

const POPUP_WIDTH = 600;
const POPUP_HEIGHT = 500;

function openSharePopup(url: string, name: string) {
    const top = window.top ?? window;
    const y = top.outerHeight / 2 + top.screenY - POPUP_HEIGHT / 2;
    const x = top.outerWidth / 2 + top.screenX - POPUP_WIDTH / 2;

    return window.open(url, name, `popup=true,width=${POPUP_WIDTH},height=${POPUP_HEIGHT},top=${y},left=${x}`);
}

function getShareData() {
    return {
        url: window.location.href,
        title: document.title,
    };
}

async function shareNative() {
    const { url, title } = getShareData();

    if (typeof navigator.share === "function") {
        await navigator.share({ title, url });
    }
}

function shareToX() {
    const { url, title } = getShareData();
    openSharePopup(
        `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`,
        "share-x"
    );
}

function shareToFacebook() {
    const { url } = getShareData();
    openSharePopup(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, "share-facebook");
}

function shareToLinkedin() {
    const { url } = getShareData();
    openSharePopup(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`, "share-linkedin");
}

await whenDomReady();

document.querySelectorAll<HTMLElement>("[data-js-share-native]").forEach((button) => {
    button.addEventListener("click", () => shareNative());
});
document.querySelectorAll<HTMLElement>("[data-js-share-x]").forEach((button) => {
    button.addEventListener("click", shareToX);
});
document.querySelectorAll<HTMLElement>("[data-js-share-facebook]").forEach((button) => {
    button.addEventListener("click", shareToFacebook);
});
document.querySelectorAll<HTMLElement>("[data-js-share-linkedin]").forEach((button) => {
    button.addEventListener("click", shareToLinkedin);
});
